<template>
<transition name="slide-fade">
    <div class="dialog-view" v-show="show">
        <div class="u-window login-modal">
            <div class="dialog-content">
                <p class="notice">当前暂未登录，请先登录！</p>
                <div class="u-btn login" @click="call_login"></div>
            </div>
        </div>
        <div class="u-mask" @click="close"></div>
    </div>
</transition>
</template>

<script>
import mslogin from '@/assets/js/msLogin';

  export default {
    name: 'loginNotice',
    data(){
        return {
            cshow : true,
        }
    },
    props: {
      text: {
        type: String,
        default: ''
      },
      show: {
        type: Boolean,
        default: false
      }
    },
    beforeDestroy() {
        //this.$el && this.$el.parentNode.removeChild(this.$el)
    },    
    methods: {
        call_login(){
            mslogin.open();
            //console.log(this);
        },
        close(){
            this.$destroy(true)  //销毁组件
            this.$el.parentNode.removeChild(this.$el)  //父元素中移除dom元素（$el为组件实例）
        },
        switch_update(boolean){
            this.show = boolean;
        },     
    },
  }
</script>

<style>
    .login-modal{
        width: 5.7rem;
        background-color: #000000;
    }

    .login-modal .dialog-content{
        padding: .5rem 0 .8rem;
    }

    .login-modal .u-btn.login{
        width: 2.14rem;
        height: .57rem;
        margin: 0 auto;
        background-image: url(~@/assets/images/btn-login.png);
    }

    .login-modal .notice{
        margin-bottom: .5rem;
        text-align: center;
        color: #fffbec;
        font-size: .24rem;
    }
</style>


// WEBPACK FOOTER //
// src/components/loginModal/loginModal.vue